import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=089befc1&scoped=true"
import script from "./merchant.vue?vue&type=script&lang=js"
export * from "./merchant.vue?vue&type=script&lang=js"
import style0 from "./merchant.vue?vue&type=style&index=0&id=089befc1&prod&lang=scss&scoped=true"
import style1 from "./merchant.vue?vue&type=style&index=1&id=089befc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089befc1",
  null
  
)

export default component.exports